// extracted by mini-css-extract-plugin
export default {"container":"styles_container__fQTB6","viewForm":"styles_viewForm__6lGKu","viewInfoBlock":"styles_viewInfoBlock__NNmTw","infoText":"styles_infoText__Wekez"};